import type {Relation} from "typeorm";
import {Column, Entity, ManyToOne, OneToMany, OneToOne, TableInheritance} from "typeorm";
import {BaseEntity} from "@/modules/base/entity/BaseEntity";
import {Team} from "@/modules/team/entity";
import {Max, Min} from "class-validator";
import {CanNegotiateInterface} from "@/modules/diplomacy/interfaces";
import {StaffNegotiation} from "@/modules/staff/entity/StaffNegotiation";

@Entity()
@TableInheritance({column: {type: "varchar", name: "type"}})
export class StaffMember extends BaseEntity implements CanNegotiateInterface {
  @ManyToOne(() => Team, Team => Team.staffMembers)
  team?: Relation<Team | null>;

  @Column({type: "varchar"})
  name: string;

  @Column({type: "integer", unsigned: true})
  @Min(1)
  @Max(100)
  skill: number;

  @Column({type: "integer", unsigned: true})
  @Min(20)
  @Max(60)
  age: number;

  @Column({type: "integer", unsigned: true})
  @Min(1)
  wage: number;

  @Column({type: "integer", unsigned: true})
  @Min(1)
  marketValue: number;

  @Column({type: "integer", unsigned: true})
  patience: number;

  @Column({type: "integer", unsigned: true})
  greediness: number;

  @Column({type: "integer", unsigned: true})
  resentfulness: number;

  @Column({type: 'boolean'})
  endsCareer = false;

  // todo remove
  @Column({type: "integer", unsigned: true})
  baseMonthlyPrice: number;

  // todo remove
  @Column({type: "integer", unsigned: true})
  baseOncePrice: number;

  @OneToMany(() => StaffNegotiation, r => r.target)
  negotiations: Relation<StaffNegotiation[]>;

  get shortName() {
    const lastName = this.name.split(' ').pop();

    return `${this.name[0]}. ${lastName}`;
  }

  get sackPrice() {
    return this.wage * 10;
  }
}